import { createContext, use } from 'react';
import type { AvailableSource } from './types';

// While the source name and source type name can be the same, they are different things.
// The first is controller by users and the former represents the name in the source description,
// so you often need to retrieve the descriptor from the backend to get that name. This implies in
// an async load that often impacts the UI.
// To avoid complex property drilling and handling async loading states in components that expect
// all data to be available, we can use this context to inject the descriptor on the top component.
const SourceDescriptorContext = createContext<AvailableSource | null>(null);
export const SourceDescriptorProvider = SourceDescriptorContext.Provider;
export const useSourceDescriptor = () => {
  return use(SourceDescriptorContext);
};
